import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/rootReducer';
import CompanyInformation from './CompanyInformation';
import OfficialFilings from './OfficialFilings';
import Team from './Team';
import Perks from './Perks';
import Graph from './Graph';
import Terms from './Terms';
import Timeline from './Timeline';
import Financials from './Financials';

const ControlledCompanyInformation = () => {
  const { data } = useSelector((state: RootState) => state.markets.offering);
  if (data) {
    return (<CompanyInformation data={data.company_information!} currency="USD" />);
  }
  return <></>;
};

const ControlledCommitments = () => {
  const { data } = useSelector(
    (state: RootState) => state.markets.offering,
  );
  if (data?.commitments) {
    return <Graph data={data.commitments} />;
  }
  return <></>;
};

const ControlledFinancials = () => {
  const { data } = useSelector((state: RootState) => state.markets.offering);
  if (data) {
    return <Financials item={data.financials!} />;
  }
  return <></>;
};

const ControlledOfficialFilings = () => {
  const { data } = useSelector((state: RootState) => state.markets.offering);
  if (data) {
    return <OfficialFilings items={data.official_accesions!} />;
  }
  return <></>;
};

const ControlledPerks = () => {
  const { data } = useSelector((state: RootState) => state.markets.offering);
  if (data) {
    return <Perks perks={data.perks!} />;
  }
  return <></>;
};

const ControlledTeam = () => {
  const { data } = useSelector((state: RootState) => state.markets.offering);
  if (data) {
    return <Team team={data.team!} />;
  }
  return <></>;
};

const ControlledTerms = () => {
  const { data } = useSelector((state: RootState) => state.markets.offering);
  if (data) {
    return <Terms terms={data.terms!} currency="USD" />;
  }
  return <></>;
};
const ControlledTimeline = () => {
  const { data } = useSelector((state: RootState) => state.markets.offering);
  if (data) {
    return <Timeline events={data.timeline} />;
  }
  return <></>;
};

export {
  ControlledCompanyInformation,
  ControlledTeam,
  ControlledOfficialFilings,
  ControlledPerks,
  ControlledCommitments,
  ControlledFinancials,
  ControlledTerms,
  ControlledTimeline,
};
